module.exports = __webpack_public_path__ + "static/media/image-saturday.d3bd7c39.jpg";